import BaseService from './baseService'
class Auth extends BaseService {
  constructor(id) {
    const resource = 'auth'
    const relationship = {}
    const baseURL = process.env.REACT_APP_API_URL
    super(id, resource, relationship, baseURL)
  }
}

export default id => new Auth(id)
